import { AuditLogEntryDto, IAuditLogEntryDto, NetworkChangeEntryDto } from "./AuditLogEntryDto";

export class AuditLogEntryListDto {
    entries:AuditLogEntryDto[] = [];
    totalCount: number;
}

export class NetworkChangeListDto {
    entries: NetworkChangeEntryDto[] = [];
    totalCount:number;
}

export interface IAuditLogEntryListDto {
    entries:IAuditLogEntryDto[];
    totalCount: number;
}